import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const noSpaceValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => {
  const value = control.value as string;
  if (value && value.trim().length === 0) {
    return {noSpace: true};
  }
  return null;
};
